import { xlCol, xlColq } from '../../common/constants'

export const selectModeData = [
  { id: 1, name: 'Paid' },
  { id: 2, name: 'Received' },
]
const commonHeaders = [
  { headerName: 'SN', field: 'SN', xlCol: xlCol, weight: 30 },
  { headerName: 'Expense Date', field: 'FormattedDate', xlCol: xlCol, weight: 90 },
  { headerName: 'Head', field: 'HeadName', xlCol: xlCol, weight: 80 },
  { headerName: 'Sub-Head', field: 'SubHeadName', xlCol: xlCol, weight: 80 },
  { headerName: 'Select Mode', field: 'Mode', xlCol: xlCol, weight: 50 },
  { headerName: 'Amount', field: 'ExpenseAmount', xlCol: xlColq, weight: 50 },
  { headerName: 'Narration', field: 'Narration', xlCol: xlCol, weight: 60 },
]
export const cityBranchHeaders = [
  { headerName: 'City', field: 'CityName', xlCol: xlCol, weight: 80 },
  { headerName: 'Branch', field: 'Branchname', xlCol: xlCol, weight: 120 },
  { headerName: 'User', field: 'UserName', xlCol: xlCol, weight: 80 },
]
export const exEntryHeaders = [...commonHeaders, { headerName: 'Action', field: 'action', xlCol: xlCol, align: 'center', weight: 30 }]
export const exApprovalHeaders = [...commonHeaders, { headerName: 'Approval', field: 'approval', xlCol: xlCol, weight: 30 }]
export const exReportHeaders = [
  ...commonHeaders,
  { headerName: 'Status', field: 'Status', xlCol: xlCol, weight: 50 },
  { headerName: 'Reject Remarks', field: 'RejectionRemarks', xlCol: xlCol, width: '200px', weight: 60 },
]
export const criteriaHeaders = [
  { field: 'fromDate', header: 'From  Date', textAlign: 'left' },
  { field: 'toDate', header: 'To  Date', textAlign: 'left' },
  { field: 'selCity', header: 'City', textAlign: 'left' },
  { field: 'selBranch', header: 'Branch', textAlign: 'left' },
  { field: 'user', header: 'User', textAlign: 'left' },
  { field: 'status', header: 'Status', textAlign: 'left' },
]
export const expenseTabsList = [
  { JobID: 573, name: 'EXPENSE ENTRY' },
  { JobID: 574, name: 'EXPENSE APPROVAL' },
  { JobID: 575, name: 'APPROVED REPORT' },
]
